import script from "./CustomDragLayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomDragLayer.vue?vue&type=script&lang=ts&setup=true"

import "./CustomDragLayer.vue?vue&type=style&index=0&id=08c69166&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c69166"]])

export default __exports__